// SelectedSlice.js
import { createSlice } from '@reduxjs/toolkit';

const SelectedSlice = createSlice({
    name: 'selected',
    initialState: {
        userData: null,  // New field for storing selected staff details
        baseData: null,
    },
    reducers: {
        setBaseData: (state, action) => {  // New reducer to store selected staff
            state.baseData = action.payload;
        },
        clearBaseData: (state) => {
            state.baseData = null;
        },
        setUserData: (state, action) => {  // New reducer to store selected staff
            state.userData = action.payload;
        },
        clearUserData: (state) => {
            state.userData = null;
        },
    }
});

export const {
    setBaseData,
    clearBaseData,
    setUserData,
    clearUserData,
} = SelectedSlice.actions;
export default SelectedSlice.reducer;
